import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground border-brand-navy/20",
        // Brand variants
        featured: "border-transparent bg-brand-gold text-brand-gold-foreground hover:bg-brand-gold/80",
        gold: "border-transparent bg-brand-gold text-brand-gold-foreground hover:bg-brand-gold/80",
        navy: "border-transparent bg-brand-navy text-brand-navy-foreground hover:bg-brand-navy/80",
        success: "border-transparent bg-success text-success-foreground hover:bg-success/80",
        warning: "border-transparent bg-warning text-warning-foreground hover:bg-warning/80",
        premium: "border-transparent bg-premium text-premium-foreground hover:bg-premium/80",
        // Subtle variants
        "outline-gold": "border-brand-gold text-brand-gold bg-brand-gold/10",
        "outline-navy": "border-brand-navy text-brand-navy bg-brand-navy/5",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
